import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './Login.css';
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL, GITHUB_AUTH_URL, ACCESS_TOKEN } from '../../constants';
import { loadCurrentlyLoggedInUser, login } from '../../util/APIUtils';
import { Link, Redirect } from 'react-router-dom'
import fbLogo from '../../img/fb-logo.png';
import googleLogo from '../../img/google-logo.png';
import githubLogo from '../../img/github-logo.png';
import Alert from 'react-s-alert';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileCallbackURL: ''
        }
    }

    componentDidMount() {
        // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
        // Here we display the error and then remove the error query parameter from the location.
        if (this.props.location.state && this.props.location.state.error) {
            setTimeout(() => {
                Alert.error(this.props.location.state.error, {
                    timeout: 5000
                });
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    state: {}
                });
            }, 100);
        }
        //if done from mobile app, capture the return_url param to call back to mobile app after login
        const urlParams = new URLSearchParams(window.location.search);
        const mobileCallbackURL = urlParams.get('mobileCallBackUrl');
        if (mobileCallbackURL) {
            console.log("Captured return_url:", mobileCallbackURL); 
            this.setState({ mobileCallbackURL: mobileCallbackURL });
        }
    }


    render() {
        if (this.state.mobileCallbackURL) {
            window.location.href = this.state.mobileCallbackURL;
        }
        if (this.props.authenticated) {
            return <Redirect
                to={{
                    pathname: "/",
                    state: { from: this.props.location }
                }} />;
        }

        return (
            <div className="login-container">
                <div className="login-content">
                    <h1 className="login-title">Login to ChasinFins</h1>
                    {/* <SocialLogin /> */}
                    {/* <div className="or-separator">
                        <span className="or-text">OR</span>
                    </div> */}
                    <LoginForm {...this.props} />
                    <span className="signup-link">New user? <Link to="/signup">Sign Up!</Link></span>
                    Mobile Callback URL: {this.state.mobileCallbackURL}
                </div>
            </div>
        );
    }
}

class SocialLogin extends Component {
    render() {
        return (
            <div className="social-login">
                <a className="btn btn-block social-btn google" href={GOOGLE_AUTH_URL}>
                    <img src={googleLogo} alt="Google" /> Log in with Google</a>
                <a className="btn btn-block social-btn facebook" href={FACEBOOK_AUTH_URL}>
                    <img src={fbLogo} alt="Facebook" /> Log in with Facebook</a>
            </div>
        );
    }
}


class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            toTrips: false,
            access_token: ''
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        const query = new URLSearchParams(window.location.search);
        if (query.get('success')) {
            this.state = { pmtMsg: 'Payment successful!  Please login' };
        }
    }


    handleInputChange(event) {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;

        this.setState({
            [inputName]: inputValue
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        const loginRequest = Object.assign({}, this.state);

        login(loginRequest)
            .then(response => {
                localStorage.setItem(ACCESS_TOKEN, response.accessToken);
                // call the parent app to update the user and state for the entier app
                //this calls App.js
                this.props.onSuccessLogin();
            }).catch(error => {
                Alert.error((error && error.message) || 'Oops! Something went wrong. Please try again!');
            });
    }

    render() {

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="form-item">
                    <b>{this.state.pmtMsg}</b><br></br><br></br>
                    <input type="email" name="email"
                        className="form-control" placeholder="Email"
                        value={this.state.email} onChange={this.handleInputChange} required />
                </div>
                <div className="form-item">
                    <input type="password" name="password"
                        className="form-control" placeholder="Password"
                        value={this.state.password} onChange={this.handleInputChange} required />
                </div>
                <div className="form-item">
                    <button type="submit" className="btn btn-block btn-primary">Login</button>
                </div>
            </form>
        );
    }
}

export default withRouter(Login)
